import React from 'react';
import { ServiceCard } from './ServiceCard';
interface Service {
  id: string;
  title: string;
  description: string;
  category: string;
  estimatedTime: string;
  fee: string;
}
interface CategorySectionProps {
  category: string;
  services: Service[];
  icon: React.ReactNode;
  buttonText?: string;
}
export const CategorySection: React.FC<CategorySectionProps> = ({
  category,
  services,
  icon,
  buttonText
}) => {
  return <div className="mb-8" data-id="element-61">
      <div className="flex items-center mb-4" data-id="element-62">
        {icon}
        <h2 className="text-xl font-semibold text-gray-900 ml-2" data-id="element-63">{category}</h2>
      </div>
      <div className="grid grid-cols-3 gap-6" data-id="element-64">
        {services.map(service => <ServiceCard key={service.id} service={service} buttonText={buttonText} data-id="element-65" />)}
      </div>
    </div>;
};